import * as Yup from 'yup';
import { CorporateAccountUpdateRequestParam } from './hooks';
import { PageStep } from 'views/pages/accountInfo/hooks';
import { ReactNode } from 'react';
// import { isEmpty } from 'lodash';
// import scrollToElement from 'scroll-to-element';

//エラー文言
export enum ErrorWord {
  SELECT = '選択してください',
  SELECT_ONE_OR_MORE = '1つ以上を選択してください',
  INPUT = '入力してください',
  INPUT_HALF_NUMBER = '半角数字で入力してください',
  UABLE_OPEN_ACCOUNT = '未同意の場合は口座開設できません',
  POSTCODE = '7桁の半角数字で入力してください（ハイフン不要）（例: 1234567）',
  BANKNUMBER = '7桁の半角数字で入力してください（ハイフン不要）（例: 1234567）',
  MOBILE_PHONE = '11桁の半角数字で入力してください（ハイフン不要）（例: 08000000000）',
  PHONE = '10桁もしくは11桁の半角数字で入力してください（ハイフン不要）（例: 0352885692）',
  HOME_PHONE_CONFIRM = '電話番号と入力が異なっています',
  FAX_PHONE = '10桁の半角数字で入力してください（ハイフン不要）（例: 0352889300）',
  CORPORATE_NUMBER = '13桁の半角数字で入力してください',
  EMAIL = 'メールアドレスの形式で入力してください（例: example@example.com）',
  EMAIL_NONE = 'メールアドレスを入力してください',
  EMAIL_CONFIRM = 'メールアドレスと入力が異なっています',
  Date = '有効な日付を入力してください',
  CAPITAL = '0より大きい整数（半角数字）で入力してください（最大11桁）',
  EMPLOYEE = '0より大きい整数（半角数字）で入力してください（最大5桁）',
  HOMEPAGE = '正しい形式で入力してください',
  MAXLENGTH = '最大{0}文字で入力してください',
  INVOICE_NUMBER = '13桁の半角数字で入力してください（ハイフン不要）（例:1234567890123）',
  FURIGANA_KATAKANA = '全角カタカナで入力してください',
}

/*--------------
  バリデーション
  --------------*/
//はい・いいえのラジオボタン条件分岐
export const yapBoolWhen = (target: string, bool: boolean, errorWord: string) =>
  Yup.bool().when(target, {
    is: bool,
    then: () => Yup.bool().nonNullable(errorWord),
    otherwise: (schema) => schema.strip(),
  });
//チェックボックス必須の条件分岐
export const yapCheckRequiredWhen = (target: string, bool: boolean, errorWord: string) =>
  Yup.bool().when(target, {
    is: bool,
    then: (schema) => schema.required(errorWord).oneOf([true], errorWord),
    otherwise: (schema) => schema.strip(),
  });
//文字列必須の条件分岐
export const yapStringWhen = (
  target: string | string[],
  bool: boolean | ((...value: any[]) => boolean),
  errorWord: string,
) =>
  Yup.string().when(target, {
    is: bool,
    then: (schema) => schema.required(errorWord),
    otherwise: (schema) => schema.strip(),
  });

const createLengthErrorWord = (length?: number) => {
  if (!length) {
    return '';
  } else {
    return `${length}桁の`;
  }
};

type YupNumberStringParam = {
  length: number;
  isRequired: boolean;
  errorWord: string;
};

export const yupNumberString = ({ length, isRequired, errorWord }: YupNumberStringParam) => {
  let schema = isRequired ? Yup.string().required(errorWord) : Yup.string().nullable();
  schema = schema.length(length, errorWord).matches(/^[0-9]*$/gi, errorWord);

  return schema;
};

//数値必須の条件分岐
export const yapNumberWhen = (
  target: string | string[],
  bool: boolean | ((value: any) => boolean),
  errorWord: string,
  length?: number,
  isAddLengthErrorWord: boolean = true,
) => {
  if (length) {
    const lengthErrorWord = isAddLengthErrorWord ? `${createLengthErrorWord(length)}${errorWord}` : errorWord;
    return Yup.number().when(target, {
      is: bool,
      then: () => yupNumberString({ length, isRequired: true, errorWord: lengthErrorWord }),
      otherwise: (schema) => schema.strip(),
    });
  } else {
    return Yup.number().when(target, {
      is: bool,
      then: () => Yup.number().required(errorWord).typeError(errorWord),
      otherwise: (schema) => schema.strip(),
    });
  }
};
// /*--------------
//   バリデーションチェックでエラーになった際のスクロール
//   --------------*/
// //className
// const formErrorClassName = 'formError';
// //スクロールの実装。エラーになっている要素に一番上にスクロール。useEffectでformikのエラーあれば使う感じ
// export const formErrorScroll = () => {
//   const formErrorElem = document.getElementsByClassName(formErrorClassName);
//   if (isEmpty(formErrorElem)) return;
//   scrollToElement(formErrorElem[0], {
//     offset: -70,
//     ease: 'in-out-quad',
//     duration: 800,
//   });
// };
// //スクロール先の要素。エラーなら表示するように実装する
// export const FormErrorScrollTarget = () => <div className={formErrorClassName} />;

//ErrorWord.MaxLengthの可変部分を埋め込む
export const getMaxLengthErrorMessage = (maxLength : number) => {
  return ErrorWord.MAXLENGTH.replace("{0}", `${maxLength}`);
};

export type LabelValue = {
  label: string | ReactNode;
  value: any;
};

type ItemStatus = {
  disabled? : boolean;
}

export type MultiSelectionsItem = LabelValue & {additional?: ReactNode} & ItemStatus;

export type TemplateProps = {
  isUpdate?: boolean;
  setPageStep?: React.Dispatch<React.SetStateAction<PageStep>>;
};
